import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { ChangeDetectorRef, Component, forwardRef, Input, OnInit, ViewChild } from '@angular/core';
import { ControlValueAccessor, UntypedFormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { chunk } from 'lodash-es';
import { startWith } from 'rxjs/operators';

import { FA_ICONS } from 'core/fa-icon-list';
import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';

@Component({
  selector: 'app-icon-select-input',
  templateUrl: './icon-select-input.component.html',
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => IconSelectInputComponent), multi: true }
  ]
})
export class IconSelectInputComponent extends WithDisposableSubject()
  implements ControlValueAccessor, OnInit {

  @Input() fullwidth = false;
  @Input() hideClearButton = false;

  private _selectedIcon: string;

  /** Is the overlay for the select open? */
  isOpen = false;

  visibleIcons = [];

  iconSearchControl = new UntypedFormControl();

  /** Reference to trigger to open the select
   *  (Used to dynamically set initial width)
   */
  @ViewChild(CdkOverlayOrigin) trigger: CdkOverlayOrigin;

  /**
   *
   */
  constructor(private cd: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {
    this.iconSearchControl.valueChanges.pipe(
      startWith('')
    ).subscribe((searchValue) => {
      this.visibleIcons = chunk(FA_ICONS.filter(x => x.includes(searchValue)), 5);
    });
  }

  private _onTouchedCallback = () => { };
  private _onChangeCallback = () => { };

  get value() {
    return this._selectedIcon;
  }

  set value(val: string) {
    this._selectedIcon = val;
    this.handleDataChanged();
  }

  writeValue(value: string): void {
    this.value = value;
    this.cd.markForCheck();
  }

  onIconSelected(icon: string) {
    this.value = icon;
    this.closeOverlay();
  }

  onClearFieldClick(event: MouseEvent) {
    event.stopPropagation();
    this.value = null;
    this.closeOverlay();
  }

  openOverlay() {
    this.isOpen = true;
  }

  closeOverlay() {
    this.isOpen = false;
  }

  registerOnChange(fn: any): void {
    this._onChangeCallback = () => fn(this.value);
  }

  registerOnTouched(fn: any): void {
    this._onTouchedCallback = () => fn(this.value);
  }

  setDisabledState?(isDisabled: boolean): void {
  }

  handleDataChanged() {
    this.cd.markForCheck();
    if (this._onChangeCallback) {
      this._onChangeCallback();
    }
  }

  handleTouched() {
    if (this._onTouchedCallback) {
      this._onTouchedCallback();
    }
  }
}
